import Person from 'src/entities/Person';

export default class User {
  id: number;
  email: string;
  physicalPersonId: number;
  juridicalPersonsId: Array<string>;
  defaultProfile: Person;
  hasCompanies?: boolean;

  constructor(entity: User) {
    this.id = entity.id;
    this.email = entity.email;
    this.physicalPersonId = entity.physicalPersonId;
    this.juridicalPersonsId = entity.juridicalPersonsId;
    this.defaultProfile = entity.defaultProfile;
    this.hasCompanies = entity.hasCompanies;
  }
}



// WEBPACK FOOTER //
// ./src/entities/User.tsx